//this closure ensures we won't be interfering with other libraries that have defined $
(function($) {
    var requestHeaderRowTemplate = {};
    var webhooksTableComponent = {};
    var webhooksTable = {};
    var displayRecords = 25;
    var ANIMATION_SPEED = 250;
    var existingWebhookNames = [];
    var webhookInformation = null;
    var hciLoginDeferred = null;
    var savedHostConnectionData = null;
    var SESSION_CONNECTION_NAME = 'webhooksLogon';
	var errorMessageStore = ErrorMessageStore;
    
    var handleAjaxRequestFailure = function(response) {
        var errorMessage = unknownErrorText;
        
        if (!!response && !!response.responseJSON && !!response.responseJSON.message) {
            errorMessage = response.responseJSON.message;
        }

        $.showErrorStatus(errorMessage);
    };
    
    var closeWebhookDialog = function() {
        $.clearStatus();
        
        $('#webhooksDialog').fadeOut(ANIMATION_SPEED, function() {
            webhookInformation = null;
            var dialogFields = $('#webhooksDialog input, #webhooksDialog textarea');
            dialogFields.removeAttr('data-dirty');
            dialogFields.removeAttr('disabled');
            dialogFields.val('');
            dialogFields.removeClass('invalid');
            $('#method')[0].value = 'POST';
            $('#webhookEnabledCheckbox').prop('checked', true);
            $('#ispwFields .switch-input').prop('checked', false);
            $('.request-headers-row').remove();
            $('#okButton').removeAttr('disabled');
        });
        
        window.scrollTo(0, 0);
    };
    
    var hciLoginCancelled = function(errorText) {
        $.showErrorStatus(errorText);
        window.scrollTo(0, 0);
    };
    
    var showHCILogin = function(productName, enabled) {
        savedHostConnectionData = null;
        hciLoginDeferred = $.Deferred();
        
        if (productName === 'ISPW' && enabled) {
            $.showHostConnectionLogonDialog.call(this, {
                dialogID : '#hostConnectionLogonDialog', 
                reconnect : false,
                storageName : SESSION_CONNECTION_NAME,
                hciContext : '../iBrowser/',
                queryString : '?webhooks=true',
                includeRuntimeConfiguration : true,
                webServicePath : 'ws'
            });
        } else {
            hciLoginDeferred.resolve();
        }        
        
        return hciLoginDeferred;
    };
    
    var addRow = function(data) {
        showHCILogin(data.product.name, data.enabled).then(function() {
            $.displayLoadingIndicator(addingText);
            hciLoginDeferred = null;
            var hciData = null;
            
            if (!!savedHostConnectionData) {
                hciData = {
                    host : savedHostConnectionData.host,
                    port : savedHostConnectionData.port,
                    userName : savedHostConnectionData.lgid,
                    key : savedHostConnectionData.parama,
                    value : savedHostConnectionData.paramb
                };
                
                savedHostConnectionData = null;
            }
            
            $.when(
                $.ajax({
                    type: 'POST',
                    data: JSON.stringify({webhook : data, hciData : hciData}),
                    url : 'ws/webhooks',
                    dataType : 'json',
                    contentType : 'application/json',
                    cache : false
                })                
            ).done(function(response) {
                closeWebhookDialog();
                var addedWebhook = response.webhook;
                var message = response.message;
                
                webhooksTable.row.add(addedWebhook);
                webhooksTable.draw();
                
                if (!!message) {
                    $.showErrorStatus(message);
                } 
            }).fail(function(response) {
                if (!!response && !!response.responseJSON && !!response.responseJSON.success) {
                    // if the webhook was added then close the dialog
                    closeWebhookDialog();
                    data.id = response.responseJSON.webhook.id;
                    webhooksTable.row.add(data);
                    webhooksTable.draw();
                }
                
                handleAjaxRequestFailure(response);
            }).always(function() {
                $.removeLoadingIndicator();
            });
        }, function() {
            hciLoginCancelled(hciLoginRequiredAddText);
        });
    };
    
    var deleteRow = function() {
        var data = webhooksTable.row('tr.row_selected').data();
        
        showHCILogin.call($('#webhooksDeleteButton'), data.product.name, data.enabled).then(function() {
            hciLoginDeferred = null;
            var hciData = null;
            
            if (!!savedHostConnectionData) {
                hciData = {
                    host : savedHostConnectionData.host,
                    port : savedHostConnectionData.port,
                    userName : savedHostConnectionData.lgid,
                    key : savedHostConnectionData.parama,
                    value : savedHostConnectionData.paramb
                };
                
                savedHostConnectionData = null;
            }

            webhooksTableComponent.showDeleteConfirmationDialog(function() {
                $.displayLoadingIndicator(deletingText);
                
                $.when(
                    $.ajax({
                        type: 'DELETE',
                        url : 'ws/webhooks/' + encodeURIComponent(data.id),
                        dataType : 'json',
                        contentType : 'application/json',
                        data: JSON.stringify({webhook : data, hciData : hciData}),
                        cache : false
                    })                
                ).done(function(response) {
                    if (!!response.success) {
                        webhooksTable.row('tr.row_selected').remove();
                        webhooksTable.draw();
                    } else {
                        $.showErrorStatus(response.message);
                        webhooksTable.row('tr.row_selected').data(response.webhook);
                        webhooksTable.draw();
                    }
                }).fail(handleAjaxRequestFailure).always(function() {
                    $.removeLoadingIndicator();
                });                
            }, null, false);
        }, function() {
            hciLoginCancelled(hciLoginRequiredRemoveText);
        });
    };
    
    var enableDialogButtons = function(errorText) {
        if ($('#webhooksDialog .invalid').length > 0) {
            // if any fields are invalid, display the error text, if provided.
            if (!!errorText) {
                $.showErrorStatus(errorText);
                $('#okButton').attr('disabled', 'disabled');
            }
        } else {
            $.clearStatus();
            
            // if all of the required fields have been edited then enable the ok button, otherwise disable the ok button
            if ($('#webhooksDialog input[required]').length === $('#webhooksDialog input[required][data-dirty]').length) {
                $('#okButton').removeAttr('disabled');
            } else {
                $('#okButton').attr('disabled', 'disabled');
            }
        }
    };
    
    var validateName = function(element) {
        var errorText = '';
        var value = element.val();
        
        if (value.length > 0) {
            if (/^[^/\#%\/\\\?\[\]&]*$/.test(value) !== true) {
                errorText = nameCharErrorText;
                errorMessageStore.set(element[0].id, errorText);
            } else  if (value.search(/^\s/g) !== -1) {
                //starts with whitespace
                errorText = nameStartErrorText;
                errorMessageStore.set(element[0].id, errorText);
            } else if (value.search(/\s$/g) !== -1) {
                //ends with whitespace
                errorText = nameEndErrorText;
                errorMessageStore.set(element[0].id, errorText);
            } else {
                var newName = value.toString().toLowerCase();
                
                if (!webhookInformation || !webhookInformation.name  || (newName !== webhookInformation.name.toString().toLowerCase())) {
                    if (!!existingWebhookNames) {
                    	var uniqueName = true;
                        for (var index = 0; index <  existingWebhookNames.length; index++) {
                            var name = existingWebhookNames[index];
                            
                            if (name.toString().toLowerCase() === newName) {
                                errorText = nameExistsErrorText;
                                errorMessageStore.set(element[0].id, errorText);
                	            uniqueName = false;
                                break;
                            }
                        }
                        if (uniqueName){
                        	errorMessageStore.remove(element[0].id);
                        }
                    }
                } else {
                	errorMessageStore.remove(element[0].id);
                }
            }
        } else if (element.attr('data-dirty') === 'true') {
            errorText = nameRequiredErrorText;
            errorMessageStore.set(element[0].id, errorText);
        } else {
        	errorMessageStore.remove(element[0].id);
        }        
        return errorText;
    };
    
    var validateUrl = function(element) {
        var errorText = '';
        var value = element.val();
        
        if (value.length > 0) {
            var urlMatch = /^https?:\/\/(\S+(:\S*)?@)?(([1-9]\d?|1\d\d|2[01]\d|22[0-3])(\.(1?\d{1,2}|2[0-4]\d|25[0-5])){2}(\.([1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(([a-z\u00a1-\uffff0-9.]-*)*[a-z\u00a1-\uffff0-9.]+))(:\d{2,5})?([/?#]\S*)?$/i.test(value);
            
            if (!urlMatch) {
                errorText = urlErrorText;
                errorMessageStore.set(element[0].id, errorText);
            } else {
            	errorMessageStore.remove(element[0].id);
            }
        } else if (element.attr('data-dirty') === 'true') {
            errorText = urlRequiredErrorText;
            errorMessageStore.set(element[0].id, errorText);
        } else {
        	errorMessageStore.remove(element[0].id);
        }
        return errorText;
    };
    
    var validateNoSpaces = function(element) {
        var errorText = '';
        
        if (element.attr('data-dirty') === 'true') {        
            var value = element.val();
            var fieldName = element.attr('data-name');
            
            if (!!value && value.length > 0) {
                var noSpaces = /^\S+$/.test(value);
                
                if (!noSpaces) {
                    errorText = noSpacesStartErrorText + ' ' + fieldName + ' ' + noSpacesEndErrorText;
                    errorMessageStore.set(element[0].id, errorText);
                } else {
                	errorMessageStore.remove(element[0].id);
                }   
            }
        }
        return errorText;
    };
    
    var validateFourCharacters = function(element) {
        var errorText = '';        
        var value = element.val();
        var fieldName = element.attr('data-name');
        if(fieldName === 'level'){
        		fieldName = 'Level';
        } else if(fieldName === 'application'){
        		fieldName = 'Application';
        }
        if (value.length === 0) {
        	errorMessageStore.remove(element[0].id);
        }
        if (!!value && value.length > 0){
        	var fourCharacterMatch = /^[a-zA-Z0-9]{1,4}(?:(,|,\s)([a-zA-Z0-9]|){1,4})*$/i.test(value);
            if (!fourCharacterMatch) {
                errorText = fieldName + ' ' + fourCharacterErrorText;
                errorMessageStore.set(element[0].id, errorText);
            } else {
            	errorMessageStore.remove(element[0].id);
            }   
        }
        return errorText;
    }
    
    var validateEventName = function(element) {
        var errorText = '';        
        var value = element.val();
        var fieldName = element.attr('data-name');
        if(fieldName === 'event name'){
    		fieldName = 'Event name';
        }
        if (value.length === 0) {
        	errorMessageStore.remove(element[0].id);
        }
        if (!!value && value.length > 0){
        	var eventNameMatch = /^[a-zA-Z0-9\s]{1,40}(?:(,|,\s)([a-zA-Z0-9\s]|){1,40})*$/i.test(value);
            if (!eventNameMatch) {
                errorText = fieldName + ' ' + eventNameErrorText;
                errorMessageStore.set(element[0].id, errorText);
            } else {
            	errorMessageStore.remove(element[0].id);
            }   
        }
        return errorText;
    }
    
    var validateRequestHeaders = function(event) {
        var $target = $(event.target);
        var $requestHeadersRow = $target.closest('.request-headers-row');
        var $keyField = $requestHeadersRow.find('.key');
        var $valueField = $requestHeadersRow.find('.value');
        var headerKey = $keyField.val();
        var headerValue = $valueField.val();
        var errorText = null;
        
        if (headerKey.trim().length === 0 && headerValue.length > 0) {
            $keyField.addClass('invalid');
            errorText = 'A header name is required.';
        } else {
            $keyField.removeClass('invalid');
            $.clearStatus();
        }
        
        enableDialogButtons(errorText);
    };
    
    var validateField = function(event) {
        if (event.type === 'focusout' && !!event.relatedTarget && event.relatedTarget.getAttribute('id') === 'cancelButton') {
            // the cancel button was clicked so don't do any validation
            return;
        }
        
        var errorText = '';
        var $target = $(event.target);
        var validationType = $target.attr('data-type');

        if (event.type === 'input' || event.type === 'focusout') {
            $target.attr('data-dirty', 'true');
        }
        
        switch (validationType) {
            case 'name' :
                errorText = validateName($target);
                break;
            case 'url' :
                errorText = validateUrl($target);
                $target = $('#url');

                if (event.type === 'focusin') {
                    $target.addClass('focus');
                } else if (event.type === 'focusout') {
                    $target.removeClass('focus');
                }
                break;
            case 'no-spaces' :
                errorText = validateNoSpaces($target);
                break;
            case 'four-characters' :
                errorText = validateFourCharacters($target);
                break;
            case 'event-name' :
            	errorText = validateEventName($target); 
                break;  
        }
      
        if (errorText.length > 0) {
            $target.addClass('invalid');
        } else {
            $target.removeClass('invalid');
        }
        
        enableDialogButtons(errorText);
    };
    
    var addRequestHeaderDOM = function(event, headerKey, headerValue) {
        $('#requestHeaders').append(Mustache.to_html(requestHeaderRowTemplate, {}));
        var $lastRow = $('#requestHeaders .request-headers-row').last();
        var $keyField = $lastRow.find('.key');
        var $valueField = $lastRow.find('.value');
        
        $keyField.focus();
        
        if (!!headerKey) {
            $keyField.val(headerKey);
        }
        
        if (!!headerValue) {
            $valueField.val(headerValue);
        }
    };
    
    var showDialog = function() {
        var tableData = webhooksTable.rows().data();
        existingWebhookNames = [];
        
        for (var index = 0; index < tableData.length; index++) {
            existingWebhookNames.push(tableData[index].name);
        }
        
        var $dialog = $('#webhooksDialog');
        var parentHeight = $('body')[0].scrollHeight;
        
        $dialog.fadeIn(ANIMATION_SPEED);
        var height = $dialog[0].scrollHeight;
        var adjustedHeight = Math.max(parentHeight, height) - (parentHeight >= height ? 52 : 0);
        
        $dialog.css('height',  adjustedHeight + 'px');
        
        if ($(this).attr('id') === 'webhooksEditButton') {
            webhookInformation = webhooksTable.row('tr.row_selected').data();
            $('#webhooksDialog input').attr('data-dirty', 'true');
            
            $('#webhookEnabledCheckbox').prop('checked', webhookInformation.enabled);
            $('#name').val(webhookInformation.name);
            
            var requestURL = webhookInformation.request.url;
            $('#url').val(requestURL);
            $('#method').val(webhookInformation.request.method).change();
            
            var requestHeaders = webhookInformation.request.httpHeaders;
            
            if (!!requestHeaders) {
                if (!Array.isArray(requestHeaders)) {
                    requestHeaders = [requestHeaders];
                }
                
                for (var index = 0; index < requestHeaders.length; index++) {
                    var requestHeader = requestHeaders[index];
                    
                    if (!!requestHeader) {
                        addRequestHeaderDOM(null, requestHeader.name, requestHeader.value);
                    }
                }
            }
            
            $('#requestBodyText').val(webhookInformation.request.body);
            $('#product')[0].value = webhookInformation.product.name;
            
            if (webhookInformation.product.name === 'ISPW') {
            	var application = webhookInformation.product.applications; 
            	if (!Array.isArray(application)) {
            		convert = [];
            		convert.push(application);
            		application = convert;
            	}
            	
            	var level = webhookInformation.product.levels; 
            	if (!Array.isArray(level)) {
            		convert = [];
            		convert.push(level);
            		level = convert;
            	}
            	
            	var eventName = webhookInformation.product.eventNames;
            	if (!Array.isArray(eventName)) {
            		convert = [];
            		convert.push(eventName);
            		eventName = convert;
            	}
                       	
            	var uniqueApps = application.reduce(function(uniqueApps,application){
            	    if (uniqueApps.indexOf(application) < 0 ) uniqueApps.push(application);
            	    return uniqueApps;
            	  },[]);

            	var uniqueLevels = level.reduce(function(uniqueLevels,level){
            	    if (uniqueLevels.indexOf(level) < 0 ) uniqueLevels.push(level);
            	    return uniqueLevels;
            	  },[]);

                $('#application').val(uniqueApps);
                
                $('#level').val(uniqueLevels); 
                $('#eventName').val(eventName);

            	if(uniqueApps[0] === '*'){$('#application').val("");}
            	if(uniqueLevels[0] === '*'){$('#level').val("");}
            	if(eventName[0] === '*'){$('#eventName').val("");}
                
                var eventTypes = webhookInformation.product.eventTypes;
                
                if (!!eventTypes) {
                    if (!Array.isArray(eventTypes)) {
                        eventTypes = [eventTypes];
                    }
                    
                    if (eventTypes[0] === '*') {
                        $('#ispwFields .switch-input').prop('checked', true);
                    } else {
                        for (var index = 0; index < eventTypes.length; index++) {
                            $('#ispwFields .switch-input[data-id="' + eventTypes[index] + '"]').prop('checked', true);
                        }
                    }
                }
            }
        }
        
        $('#name').focus();
        enableDialogButtons();
    };
    
    var persistWebhook = function() {
        var $requestHeaderRows = $('.request-headers-row');
        var requestHeaders = [];
        
        for (var index = 0; index < $requestHeaderRows.length; index++) {
            var $row = $($requestHeaderRows[index]);
            var headerKey = $row.find('.key').val().trim();
            
            if (!!headerKey) {
                requestHeaders.push({
                    name : headerKey,
                    value : $row.find('.value').val().trim()
                });
            }
        }
        
        var product = {
            name : $('#product').val().trim()
        };
        
        if (product.name === 'ISPW') {
            var eventTypes = [];
            var applications = [];
            var levels = [];
            var eventNames = [];
            
            var selectedEventTypes = $('#ispwFields .switch-input:checked');
            var eventTypesCount = $('#ispwFields .switch-input').length;
            
            if (selectedEventTypes.length > 0) {
                if (selectedEventTypes.length === 0 || selectedEventTypes.length === eventTypesCount) {
                    // All of the event types were selected so send the wildcard string
                    eventTypes.push('*');
                } else {
                    for (var index = 0; index < selectedEventTypes.length; index++) {
                        var dataID = $(selectedEventTypes[index]).attr('data-id');
                        
                        if (!!dataID) {
                            eventTypes.push(dataID);
                        }
                    }
                }
            }
            
            product['@xsi.type'] = ispwXsiType;
            var app = $('#application').val().trim();
            app = app.replace(/ /g, '');
            app = app.split(",");
            if (app.length === 1) {
            	applications.push(app[0]);
            }
            else {
	            for (var i = 0; i < app.length; i++) {
	            	if (app[i] !== null && app[i] !== "" && app[i] !== ",") {
	            		applications.push(app[i]);
	            	}
	            }
            }
            
            var lev = $('#level').val().trim();
            lev = lev.replace(/ /g, '');
            lev = lev.split(",");
            if (lev.length === 1) {
            	levels.push(lev[0]);
            }
            else {
	            for (var j = 0; j <lev.length; j++) {
	            	if (lev[j] !== null && lev[j] !== "" && lev[j] !== ",")
	            		levels.push(lev[j]);
	            }
            }
            var evName = $('#eventName').val().trim();
            evName = evName.replace(/ /g, '');
            evName = evName.split(",");
            if (evName.length === 1) {
            	eventNames.push(evName[0]);
            }
            else {
	            for (var k = 0; k < evName.length; k++) {
	            	if (evName[k]!== null && evName[k] !== "" && evName[k]!==",") {
	            		eventNames.push(evName[k]);
	            	}
	            }
            }
            product.applications = applications;
            if(product.applications[0] === ''){product.applications[0] = '*';}
            product.levels = levels;
            if(product.levels[0] === ''){product.levels[0] = '*';}
            product.eventNames = eventNames;
            if(product.eventNames[0] === ''){product.eventNames[0] = '*';}
            product.eventTypes = eventTypes;
        }
        
        var data = {
            enabled : $('#webhookEnabledCheckbox').prop('checked'),
            name : $('#name').val().trim(),
            request : {
                url : $('#url').val().trim(),
                httpHeaders : requestHeaders,
                method : $('#method').val().trim(),
                body : $('#requestBodyText').val().trim()
            },
            product : product
        };
        
        if (!!webhookInformation) {
            // editing a webhook, pass true as the enabled flag to showHCILogin because we need to notify the
            // mainframe product stop or start the notifications, and that will require being authenticated.
            showHCILogin(webhookInformation.product.name, true).then(function() {
                $.displayLoadingIndicator(updatingText);
                hciLoginDeferred = null;
                
                var hciData = {
                    host : savedHostConnectionData.host,
                    port : savedHostConnectionData.port,
                    userName : savedHostConnectionData.lgid,
                    key : savedHostConnectionData.parama,
                    value : savedHostConnectionData.paramb,
                    rtConfig : savedHostConnectionData.rtConfig
                };
                
                data.id = webhookInformation.id;
                
                $.when(
                    $.ajax({
                        type: 'PUT',
                        data: JSON.stringify({webhook : data, hciData : hciData}),
                        url : 'ws/webhooks/' + data.id,
                        dataType : 'json',
                        contentType : 'application/json',
                        cache : false
                    })
                ).done(function(response) {
                    if (!!response.webhook) {
                        // we will only get a webhook returned if the add occurred
                        closeWebhookDialog();
                        var $row = $('#webhooksTable tr.row_selected');
                        webhooksTable.row($($row[0])).data(response.webhook);
                        
                        if (data.enabled) {
                            $row.removeClass('disabled-webhook');
                        } else {
                            $row.addClass('disabled-webhook');
                        }
                        
                        webhooksTable.draw();
                    }
                    
                    if (!!response.message) {
                        // if we got a message then an error occurred in either the delete or add.
                        $.showErrorStatus(response.message);
                    }
                }).fail(handleAjaxRequestFailure).always(function() {
                    $.removeLoadingIndicator();
                });
            }, function() {
                hciLoginCancelled(hciLoginRequiredEditText);
            });
        } else {
            // adding a webhook
            addRow(data);
        }
    };
    
    var okButtonClicked = function() {
        var product = $('#product').val();
        
        if (product === 'ISPW' && $('#ispwFields .switch-input:checked').length === 0) {
            $.showErrorStatus(eventTypeRequiredErrorText);
            $('#okButton').attr('disabled', 'disabled');
            window.scrollTo(0, 0);
        } else {
            persistWebhook();
        }
    };
    
    // The document has finished loading, let's do our stuff
    $(document).ready(function() {
        $.displayLoadingIndicator(loadingText);
        requestHeaderRowTemplate = $('#requestHeaderRowTemplate').html().trim();
        
        $.when(
            $.ajax({
                type: 'GET',
                url : 'ws/webhooks',
                dataType : 'json',
                contentType : 'application/json',
                cache : false
            })
        ).done(function(response) {
            var webhooksData = [];
            
            if (!!response && !!response.webhooks) {
                if (Array.isArray(response.webhooks)) {
                    webhooksData = response.webhooks;
                } else {
                    webhooksData.push(response.webhooks);
                }
            }
            
            var headers = [{
                title : nameColumnText 
            }, {
                title : urlColumnText 
            }, {
                title : requestMethodColumnText 
            }];
             
            var webhooksTableOptions = {
                columns : [
                    {
                        data : 'name',
                        defaultContent : '',
                        render : function (name, type, rowData) {
                            var displayName = name;
                            
                            if ((type === 'display' || type === 'filter' || type === 'sort') && !rowData.enabled) {
                                displayName = displayName + ' ' + disabledSuffixText;
                            }
                            
                            return displayName;
                        }
                    },
                    {
                        data : 'request.url',
                        defaultContent : ''
                    },
                    {
                        data : 'request.method',
                        defaultContent : 'POST'
                    }
                ],
                order : [[0, 'asc']],
                data : webhooksData,
                createdRow: function(row, data) {
                    if (!data.enabled) {
                        $(row).addClass('disabled-webhook');
                    }
                }  
            };
            
            var tableControls = {};
            
            if (typeof authorized !== 'undefined' && !!authorized) {
                tableControls = {
                    addButton : {
                        clazz : 'add-button',
                        callback : showDialog
                    },
                    editButton : {
                        clazz : 'edit-button',
                        callback : showDialog,
                        disabled : 'disabled',
                        enablement : 'single'
                    },
                    deleteButton : {
                        clazz : 'table-delete-button',
                        disabled : 'disabled',
                        enablement : 'single',
                        callback : deleteRow
                    }  
                };
            }
            
            webhooksTableComponent = new SimpleTableComponent('webhooks', '#webhooksTableContainer', headers);
            webhooksTable = webhooksTableComponent.createTable(webhooksTableOptions, 'single', null, null, tableControls);            
            
            $('#okButton').click(okButtonClicked);
            $('#cancelButton').click(closeWebhookDialog);

    		$('#webhooksDialog input').on('click', function(event){event.stopPropagation();});
    		$('#webhooksDialog button').on('click', function(event){event.stopPropagation();});
    		$("html").on("click", function(){$.clearStatus();});
            
            $('#webhooksDialog input').on('input focusin focusout', validateField);
            
            $('#method').on('change', function() {
                var text = $('#method option:selected').text();
                var $requestBodyText = $('#requestBodyText');
                
                if (text === 'GET' || text === 'DELETE') {
                    $requestBodyText.val('');
                    $requestBodyText.attr('disabled', 'disabled');
                } else {
                    $requestBodyText.removeAttr('disabled');
                }
            });
            
            $('#addHeader').on('click', addRequestHeaderDOM);
            
            $('#requestHeaders').on('click', '.remove-header', function() {
                $(this).closest('.request-headers-row').remove();
                enableDialogButtons();
            });
            
            $('#requestHeaders').on('input focusin focusout', 'input', validateRequestHeaders);
            
            $('.webhooks-contents').fadeIn();
            
            $(window).on('hostConnectionLogon', function(event, hostConectionLogon, hostConnectionData) {
            	if (!!hostConnectionData) {
                    savedHostConnectionData = JSON.parse(hostConnectionData);
            	} else {
            		throw new Error('hostConnectionData cannot be null.')
            	}
            	
                hciLoginDeferred.resolve();
                //remove the logon information from session storage so we can log in again if needed.
                sessionStorage.removeItem(SESSION_CONNECTION_NAME);
            });
            
            $(window).on('hostConnectionCancelled', function() {
                hciLoginDeferred.reject();
            });
        }).fail(handleAjaxRequestFailure).always(function() {
            $.removeLoadingIndicator();
        });
    });
})(jQuery);